import { LookupData } from "../../Models/LoookupData";
import LookupService from "../../Services/LookupService";
import { SelectOption } from "../../shared/components/input";
import Customer from "../model/Customer";
import * as constant from '../../shared/util/constant';
import { canDeleteCustomer, createCustomer, deleteCustomer, fetchCustomer, updateCustomer } from "../services/CustomerAPI";
import validator from 'validator';
import { lookup } from "dns";
import { getAgenciesByGroup } from "../services/CustomerAPI";

class CustomerDetailService {
    public fetchCustomerById = async (id: string) => {
        var customerData = await fetchCustomer(id);
        customerData.customerNotes = customerData.customerNotes.sort((a, b) => b.changedDate.localeCompare(a.changedDate));
        return customerData;
    }

    public saveCustomer = async (customerData: Customer): Promise<Customer> => {
        let custToUpdate = this.getCustomerToUpdate(customerData);
        let apiResponse: Customer = null;
        if (this.isExistingCustomer(custToUpdate)) {
            apiResponse = await updateCustomer(custToUpdate);
        }
        else {
            apiResponse = await createCustomer(custToUpdate);
        }

        return apiResponse;
    }

    public canDeleteCustomer = async (id: string): Promise<string> => {
        let apiResponse = await canDeleteCustomer(id);
        return apiResponse;
    }

    public deleteCustomer = async (id: string): Promise<string> => {
        let apiResponse = await deleteCustomer(id);
        return apiResponse;
    }

    public isExistingCustomer = (customer: Customer): boolean => {
        if (!customer) {
            return false;
        }

        if (!customer.id) {
            return false;
        }

        return true;
    }

    public fetchComponentInitData = async (agencyGroupId) => {     
              
        let maritalStatusList = await LookupService.fetchMaritalStatuses();
        let industryList = await LookupService.fetchIndustries();
        let occupancyList = await LookupService.fetchOccupancies();
        let relationshipList = await LookupService.fetchRelationships();
        let countryList = await LookupService.fetchCountries();
        let stateUSList = await LookupService.fetchUSStates();
        let genderList = await LookupService.fetchGenderState();
        let individualizedList = await LookupService.fetchIndividualizedState();

        let stateUSOptions = stateUSList ? stateUSList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
        let stateCanadaList = await LookupService.fetchCanadaStates();
        let stateCanadaOptions = stateCanadaList ? stateCanadaList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
        let stateList = await LookupService.fetchState();
        let stateOptions = stateList ? stateList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
        //let agencyList = await LookupService.fetchAgencies();
        let agencyList =  await getAgenciesByGroup(agencyGroupId);

        let agencyOptions = agencyList ? agencyList.map(item => {
            return {
                label: item.description,
                value: item.id,
                isInactive: false
            }
        }) : [];

        return {
            maritalStatusList: this.mapToSelectOptions(maritalStatusList),
            industryList: this.mapToSelectOptions(industryList),
            occupancyList: this.mapToSelectOptions(occupancyList),
            relationshipList: this.mapToSelectOptions(relationshipList),
            genderList: this.mapToSelectOptions(genderList),
            stateList: stateOptions,
            agencyList: agencyOptions,
            countryList: this.mapToSelectOptions(countryList),
            stateUSList: stateUSOptions,
            stateCanadaList: stateCanadaOptions,
            individualizedList: this.mapToSelectOptions(individualizedList)
        };
    }

    // public getGenderList = (): SelectOption[] => {
    //     return CustomerDetailService.genderList;
    // }

    public validateCustomer = (customer: Customer): any => {
        let validationErrors = {};
        if (!customer) {
            validationErrors['rootObject'] = { isValid: false, warningText: constant.CUSTOMER_SPECIFY_CUSTOMER_DETAILS }
        }

        if ((!customer.firstName || customer.firstName?.trim().length == 0)
            && (!customer.lastName || customer.lastName?.trim().length == 0)
            && (!customer.displayName || customer.displayName?.trim().length == 0)) {
            validationErrors['firstName'] = { isValid: false, warningText: constant.CUSTOMER_MANDATORY_FIELDS_ERROR };
            validationErrors['lastName'] = { isValid: false, warningText: constant.CUSTOMER_MANDATORY_FIELDS_ERROR };
            validationErrors['displayName'] = { isValid: false, warningText: constant.CUSTOMER_MANDATORY_FIELDS_ERROR };
        }

        if (customer.firstName?.trim().length > 0 && customer.firstName?.trim().length < 2) {
            validationErrors['firstName'] = { isValid: false, warningText: constant.CUSTOMER_FIRST_NAME_MIN_LENGTH };
        }

        if (customer.lastName?.trim().length > 0 && customer.lastName?.trim().length < 2) {
            validationErrors['lastName'] = { isValid: false, warningText: constant.CUSTOMER_LAST_NAME_MIN_LENGTH };
        }
        if (customer.displayName?.trim().length > 0 && customer.displayName?.trim().length < 2) {
            validationErrors['displayName'] = { isValid: false, warningText: constant.CUSTOMER_DISPLAY_NAME_MIN_LENGTH };
        }

        if (!customer.agencyId || customer.agencyId?.length == 0) {
            validationErrors['agencyId'] = { isValid: false, warningText: constant.CUSTOMER_AGENCY_MANDATORY };
        }

        if (customer.yearEmployed && customer.yearEmployed?.length > 0) {
            let yearEmployedValue = parseFloat(customer.yearEmployed);
            if (isNaN(yearEmployedValue)) {
                validationErrors['yearEmployed'] = { isValid: false, warningText: constant.CUSTOMER_YEAR_EMPLOYED_NUMERIC };
            }
            else if (yearEmployedValue < 1990) {
                validationErrors['yearEmployed'] = { isValid: false, warningText: constant.CUSTOMER_YEAR_EMPLOYED_RANGE };
            }
        }

        if (customer.eMail?.trim().length > 0 && !validator.isEmail(customer.eMail?.trim())) {
            validationErrors['eMail'] = { isValid: false, warningText: constant.CUSTOMER_INVALID_EMAIL };
        }

        if (customer.eMail2?.trim().length > 0 && !validator.isEmail(customer.eMail2?.trim())) {
            validationErrors['eMail2'] = { isValid: false, warningText: constant.CUSTOMER_INVALID_EMAIL };
        }
        if (customer.email3?.trim().length > 0 && !validator.isEmail(customer.email3?.trim())) {
            validationErrors['email3'] = { isValid: false, warningText: constant.CUSTOMER_INVALID_EMAIL };
        }
        if (customer.email4?.trim().length > 0 && !validator.isEmail(customer.email4?.trim())) {
            validationErrors['email4'] = { isValid: false, warningText: constant.CUSTOMER_INVALID_EMAIL };
        }
        if (customer.email5?.trim().length > 0 && !validator.isEmail(customer.email5?.trim())) {
            validationErrors['email5'] = { isValid: false, warningText: constant.CUSTOMER_INVALID_EMAIL };
        }
        if (!customer.address1 || customer.address1?.length == 0) {
            validationErrors['address1'] = { isValid: false, warningText: constant.FIELD_BLANK };
        }
        if (!customer.city || customer.city?.length == 0) {
            validationErrors['city'] = { isValid: false, warningText: constant.FIELD_BLANK };
        }
        //for USA for 80101
        if (customer.countryId ==constant.DATA_IDs.COUNTRIES.USA && (!customer.state || customer.state?.length == 0)) {
            validationErrors['state'] = { isValid: false, warningText: constant.FIELD_BLANK };
        }
         if ( !customer.isBillAddressSame && customer.countryId ==constant.DATA_IDs.COUNTRIES.USA && (!customer.billState || customer.billState?.length == 0)) {
            validationErrors['billState'] = { isValid: false, warningText: constant.FIELD_BLANK };

        }
        if (!customer.zipCode || customer.zipCode?.length == 0) {
            validationErrors['zipCode'] = { isValid: false, warningText: constant.FIELD_BLANK };
        }


        if (customer.address1?.trim().length > 0 && customer.address1?.trim().length < 2) {
            validationErrors['address1'] = { isValid: false, warningText: constant.CUSTOMER_ADDRESS1_MIN_LENGTH };
        }

        if (customer.city?.trim().length > 0 && customer.city?.trim().length < 2) {
            validationErrors['city'] = { isValid: false, warningText: constant.CUSTOMER_CITY_MIN_LENGTH };
        }
        let customerZip = customer.zipCode?.replace("-", "");
        if(customer.countryId ==constant.DATA_IDs.COUNTRIES.USA){
             if (customerZip?.trim().length > 0 && customerZip?.trim().length < 5) {
                 validationErrors['zipCode'] = { isValid: false, warningText: constant.CUSTOMER_ZIP_MIN_LENGTH };
             } else if (!customerZip || customerZip.length < 5 || (customerZip.length > 5 && customerZip.length != 9)) {
                 validationErrors['zipCode'] = { isValid: false, warningText: constant.INVALID_ZIPCODE };
             }
        }else{
            if (customerZip?.trim().length > 0 && customerZip?.trim().length < 2) {
                validationErrors['zipCode'] = { isValid: false, warningText: constant.CUSTOMER_NON_USA_ZIP_MIN_LENGTH };
            }
        }
        let customerBillZip = customer.billZip?.replace("-", "");
        if(customer.isBillAddressSame != true){
                if (customer.billZip != undefined) {
                    if(customer.countryId ==constant.DATA_IDs.COUNTRIES.USA){
                    if (customerBillZip?.trim().length > 0 && customerBillZip?.trim().length < 5) {
                        validationErrors['billZip'] = { isValid: false, warningText: constant.CUSTOMER_ZIP_MIN_LENGTH };
                    } else if (customerBillZip.length > 5 && customerBillZip.length != 9) {
                        validationErrors['billZip'] = { isValid: false, warningText: constant.INVALID_ZIPCODE };
                    }
                    }
                else{
                    if (customerBillZip?.trim().length > 0 && customerBillZip?.trim().length < 2) {
                        validationErrors['billZip'] = { isValid: false, warningText: constant.CUSTOMER_NON_USA_ZIP_MIN_LENGTH };
                }
                }
            }
        }

        const homePhoneDigits = customer.homePhone?.replace(/\D/g, '') || '';
        if (homePhoneDigits.length > 0 && homePhoneDigits.length < 10) {
            validationErrors['homePhone'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }

        const mobileDigits = customer.mobile?.replace(/\D/g, '') || '';
        if (mobileDigits.length > 0 && mobileDigits.length < 10) {
            validationErrors['Phone'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }

        const workPhoneDigits = customer.workPhone?.replace(/\D/g, '') || '';
        if (workPhoneDigits.length > 0 && workPhoneDigits.length < 10) {
            validationErrors['workPhone'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }

        const otherPhone1Digits = customer.otherPhone1?.replace(/\D/g, '') || '';
        if (otherPhone1Digits.length > 0 && otherPhone1Digits.length < 10) {
            validationErrors['otherPhone1'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }

        const otherPhone2Digits = customer.otherPhone2?.replace(/\D/g, '') || '';
        if (otherPhone2Digits.length > 0 && otherPhone2Digits.length < 10) {
            validationErrors['otherPhone2'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }

        const otherPhone3Digits = customer.otherPhone3?.replace(/\D/g, '') || '';
        if (otherPhone3Digits.length > 0 && otherPhone3Digits.length < 10) {
            validationErrors['otherPhone3'] = { isValid: false, warningText: constant.CONTACT_NO_RANGE };
        }
        customer.customerDependents?.forEach(item => {
            if ((!item.firstName || item.firstName?.trim().length == 0) && (!item.lastName || item.lastName?.trim().length == 0)) {
                this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'firstName', constant.CUSTOMER_MANDATORY_DEPEDENT_FIELDS_ERROR);
                this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'lastName', constant.CUSTOMER_MANDATORY_DEPEDENT_FIELDS_ERROR);
            }

            if (item.yearEmployed && item.yearEmployed?.length > 0) {
                let dpYearEmployedValue = parseFloat(item.yearEmployed);
                if (isNaN(dpYearEmployedValue)) {
                    this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'yearEmployed', constant.CUSTOMER_YEAR_EMPLOYED_NUMERIC);
                }
                else if (dpYearEmployedValue < 1990) {
                    this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'yearEmployed', constant.CUSTOMER_YEAR_EMPLOYED_RANGE);
                }
            }
            const depHomePhoneDigits = item.homePhone?.replace(/\D/g, '') || '';
            if (depHomePhoneDigits.length > 0 && depHomePhoneDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'homePhone', constant.CONTACT_NO_RANGE);
            }

            const depMobileDigits = item.mobile?.replace(/\D/g, '') || '';
            if (depMobileDigits.length > 0 && depMobileDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'mobile', constant.CONTACT_NO_RANGE);
            }

            const depWorkPhoneDigits = item.workPhone?.replace(/\D/g, '') || '';
            if (depWorkPhoneDigits.length > 0 && depWorkPhoneDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerDependents', item.depdId, 'workPhone', constant.CONTACT_NO_RANGE);
            }
        });

        customer.customerContacts?.forEach(item => {
            console.log('validation')
            if ((!item.contactName || item.contactName?.trim().length == 0)) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'contactName', constant.CompanyContact.BLANK_FIELD);
            }

            if ((item.contactName?.trim().length > 0 && item.contactName?.trim().length < 2)) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'contactName', constant.CompanyContact.NAME_LENGTH_RANGE);
            }

            if (!item.title || item.title?.trim().length == 0) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'title', constant.CompanyContact.BLANK_FIELD);
            }

            if ((item.title?.trim().length > 0 && item.title?.trim().length < 2)) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'title', constant.CompanyContact.TITLE_LENGTH_RANGE);
            }
            const contactHomePhoneDigits = item.homePhone?.replace(/\D/g, '') || '';
            if (contactHomePhoneDigits.length > 0 && contactHomePhoneDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'homePhone', constant.CompanyContact.WORK_PHONE_RANGE);
            }

            const contactMobileDigits = item.mobile?.replace(/\D/g, '') || '';
            if (contactMobileDigits.length > 0 && contactMobileDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'mobile', constant.CompanyContact.WORK_PHONE_RANGE);
            }

            const contactWorkPhoneDigits = item.workPhone?.replace(/\D/g, '') || '';
            if (contactWorkPhoneDigits.length === 0) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'workPhone', constant.CompanyContact.BLANK_FIELD);
            } else if (contactWorkPhoneDigits.length < 10) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'workPhone', constant.CompanyContact.WORK_PHONE_RANGE);
            }
            if (item.zip != null) {
                if(item.countryId ==constant.DATA_IDs.COUNTRIES.USA){
                let itemZip = item.zip?.replace("-", "");
                if (itemZip?.trim().length > 0 && itemZip?.trim().length < 5) {
                    this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'zip', constant.CUSTOMER_ZIP_MIN_LENGTH);
                } else if (itemZip.length > 5 && itemZip.length != 9) {
                    this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'zip', constant.CompanyContact.INVALID_ZIPCODE);
                }
            }  else{
                if (item.zip?.trim().length > 0 && item.zip?.trim().length < 2) {
                     this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'zip', constant.CUSTOMER_NON_USA_ZIP_MIN_LENGTH);}
            }
            }
            if (item.email?.trim().length > 0 && !validator.isEmail(item.email?.trim())) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'email', constant.CUSTOMER_INVALID_EMAIL);
            }

            if (!item.zip) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'zip', constant.FIELD_BLANK);
            }
            if ((item.countryId == constant.DATA_IDs.COUNTRIES.USA || item.countryId == constant.DATA_IDs.COUNTRIES.CANADA) && (!item.state)) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'state', constant.FIELD_BLANK);
            }
            if (!item.city) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'city', constant.FIELD_BLANK);
             }
            if (item.city?.trim().length > 0 && item.city?.trim().length < 2) {
                this.setSubEntityValidationError(validationErrors, 'customerContacts', item.id, 'city',  constant.CUSTOMER_CITY_MIN_LENGTH);
            }
        });

        return validationErrors;
    }

    public validateEmail= (emailAddress: string): any => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (emailAddress != "" && emailRegex.test(emailAddress)) {
            return true;
        }
    }

    public validationForZipCode = (propName: string, val: string, isUSA?:boolean): any => {
        let validationErrors = {};
        if(isUSA != false){
            if (val != undefined && val.toString().length > 0) {
                let zipCode = val.replace("-", "");
                if (zipCode?.trim().length < 5) {
                    validationErrors[propName] = { isValid: false, warningText: constant.CUSTOMER_ZIP_MIN_LENGTH };
                } else if (!zipCode
                    || zipCode.length < 5
                    || (zipCode.length > 5 && zipCode.length != 9)) {
                    validationErrors[propName] = { isValid: false, warningText: constant.INVALID_ZIPCODE };
                }
         }
        }
        else{
             if (val?.trim().length < 2) {
                    validationErrors[propName] = { isValid: false, warningText: constant.CUSTOMER_NON_USA_ZIP_MIN_LENGTH };
                }
        }
       
        return validationErrors;
    }

    private setSubEntityValidationError = (validationErrors: any, subEntityPropName: string, depdId: string, fieldName: string, errorMessage: string) => {
        if (!validationErrors[subEntityPropName]) {
            validationErrors[subEntityPropName] = {};
        }

        if (!validationErrors[subEntityPropName][depdId]) {
            validationErrors[subEntityPropName][depdId] = {};
        }

        validationErrors[subEntityPropName][depdId][fieldName] = { isValid: false, warningText: errorMessage };
    }

    private getCustomerToUpdate = (customer: Customer): Customer => {
        let customerToUpdate: Customer = {};

        customerToUpdate.id = customer.id;
        customerToUpdate.custNumber = customer.custNumber;
        customerToUpdate.firstName = customer.firstName?.trim();
        customerToUpdate.midName = customer.midName?.trim();
        customerToUpdate.lastName = customer.lastName?.trim();
        customerToUpdate.displayName = customer.displayName?.trim();
        customerToUpdate.agencyId = customer.agencyId;
        customerToUpdate.industryId = customer.industryId;
        customerToUpdate.occupationId = customer.occupationId;
        customerToUpdate.yearEmployed = customer.yearEmployed;
        customerToUpdate.gender = customer.gender;
        customerToUpdate.maritalStatusId = customer.maritalStatusId;
        customerToUpdate.vip = customer.vip;
        customerToUpdate.address1 = customer.address1?.trim();
        customerToUpdate.address2 = customer.address2?.trim();
        customerToUpdate.countryId = customer.countryId;
        customerToUpdate.city = customer.city?.trim();
        customerToUpdate.state = customer.state?.trim();
        customerToUpdate.zipCode = customer.zipCode?.trim();
        customerToUpdate.billAddress1 = customer.billAddress1?.trim();
        customerToUpdate.billAddress2 = customer.billAddress2?.trim();
        customerToUpdate.billCity = customer.billCity?.trim();
        customerToUpdate.billState = customer.billState?.trim();
        customerToUpdate.billZip = customer.billZip?.trim();
        customerToUpdate.isBillAddressSame = customer.isBillAddressSame;
        customerToUpdate.mailOptOut = customer.mailOptOut;
        customerToUpdate.emailOptOut = customer.emailOptOut;
        customerToUpdate.callOptOut = customer.callOptOut;
        customerToUpdate.smsOptOut = customer.smsOptOut;
        customerToUpdate.eddOptIn = customer.eddOptIn;
        customerToUpdate.mobile = customer.mobile?.replaceAll('-', '').trim();
        customerToUpdate.mobileSmsOptIn = customer.mobileSmsOptIn;
        customerToUpdate.workPhone = customer.workPhone?.replaceAll('-', '').trim();
        customerToUpdate.workPhoneSmsOptIn = customer.workPhoneSmsOptIn;
        customerToUpdate.homePhone = customer.homePhone?.replaceAll('-', '').trim();
        customerToUpdate.otherPhone1 = customer.otherPhone1?.replaceAll('-', '').trim();
        customerToUpdate.otherPhone1SmsOptIn = customer.otherPhone1SmsOptIn;
        customerToUpdate.otherPhone2 = customer.otherPhone2?.replaceAll('-', '').trim();
        customerToUpdate.otherPhone2SmsOptIn = customer.otherPhone2SmsOptIn;
        customerToUpdate.otherPhone3 = customer.otherPhone3?.replaceAll('-', '').trim();
        customerToUpdate.otherPhone3SmsOptIn = customer.otherPhone3SmsOptIn;
        customerToUpdate.eMail = customer.eMail?.trim();
        customerToUpdate.eMail2 = customer.eMail2?.trim();
        customerToUpdate.email3 = customer.email3?.trim();
        customerToUpdate.email4 = customer.email4?.trim();
        customerToUpdate.email5 = customer.email5?.trim();
        customerToUpdate.individualizedId = customer.individualizedId;

        customerToUpdate.customerDependents = [];
        customerToUpdate.customerContacts = [];
        customer.customerDependents?.forEach(item => {
            let depd = {
                custId: item.custId,
                depdId: item.custId ? item.depdId : null, // Copy depdId only if custId is present as for newly added dependents custid would be null.
                relationshipId: item.relationshipId,
                firstName: item.firstName?.trim(),
                midName: item.midName?.trim(),
                lastName: item.lastName?.trim(),
                industryId: item.industryId,
                occupationId: item.occupationId,
                yearEmployed: item.yearEmployed,
                maritalStatusId: item.maritalStatusId,
                mobile: item.mobile?.replaceAll('-', '').trim(),
                workPhone: item.workPhone?.replaceAll('-', '').trim(),
                homePhone: item.homePhone?.replaceAll('-', '').trim(),
                isModified: item.isModified
            };

            customerToUpdate.customerDependents.push(depd);
        });
        customer.customerContacts?.forEach(item => {
            let contactinfo = {
                id: item.id,
                custId: item.custId,
                contactName: item.contactName?.trim(),
                title: item.title?.trim(),
                address1: item.address1?.trim(),
                address2: item.address2?.trim(),
                city: item.city?.trim(),
                countryId: item.countryId?.trim(),
                state: item.state?.trim(),
                zip: item.zip?.trim(),
                county: item.county?.trim(),
                homePhone: item.homePhone?.replaceAll('-', '').trim(),
                workPhone: item.workPhone?.replaceAll('-', '').trim(),
                mobile: item.mobile?.replaceAll('-', '').trim(),
                email: item.email?.trim(),
                webAddr: item.webAddr?.trim(),
                formalSalutation: item.formalSalutation?.trim(),
                WorkPhoneExt: item.workPhoneExt?.replaceAll('-', '').trim(),
                isModified: item.isModified
            }
            customerToUpdate.customerContacts.push(contactinfo);
        })
        return customerToUpdate;
    }

    private mapToSelectOptions = (lookupData: LookupData[]): SelectOption[] => {
        return lookupData?.map(item => {
            return {
                label: item.lookupValue,
                value: item.id,
                isInactive: item.inactive
            };
        });
    }
}


export default CustomerDetailService;